import axios, { AxiosResponse } from 'axios';

export default function deleteAsync(apiUrl: string) {
  return function api<TResponse>(id: string | undefined | null): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/pilot-lines/${id}`,
          method: 'DELETE',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
